// Navigation scripts
import { createFocusTrap } from './focus-trap.js';

const mobilemenu = {
    addEvents: function () {
        //Menu Toggle
        var mobiletoggle = document.getElementById('burger-menu');
        var mobilemenuEl = document.getElementById('mob-menu');

        var mobileHeader = mobilemenuEl.closest('.mobile-header');
        var trap = createFocusTrap(mobileHeader, {
            onClose: closeMenu,
            escapeCloses: true
        });

        function openMenu() {
            mobiletoggle.classList.add('open');
            mobilemenuEl.classList.add('open');
            document.body.classList.add('modal-open');
            mobiletoggle.setAttribute('aria-expanded', 'true');
            mobilemenuEl.setAttribute('aria-hidden', 'false');
            trap.activate(mobiletoggle);
            var firstFocusable = mobilemenuEl.querySelector('input, a[href], button:not([disabled])');
            if (firstFocusable) {
                firstFocusable.focus();
            }
        }

        function closeMenu() {
            mobilemenuEl.classList.remove('open');
            document.body.classList.remove('modal-open');
            mobiletoggle.classList.remove('open');
            mobiletoggle.setAttribute('aria-expanded', 'false');
            mobilemenuEl.setAttribute('aria-hidden', 'true');
            trap.deactivate();
            // Close any open submenus
            var openSubmenus = mobilemenuEl.querySelectorAll('.mega-nav.open');
            for (var i = 0; i < openSubmenus.length; i++) {
                openSubmenus[i].classList.remove('open');
                openSubmenus[i].inert = true;
                var trigger = openSubmenus[i].previousElementSibling;
                if (trigger && trigger.hasAttribute('aria-expanded')) {
                    trigger.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                }
            }
        }

        mobiletoggle.onclick = function () {
            var isOpen = mobilemenuEl.classList.contains('open');
            if (isOpen) {
                closeMenu();
            } else {
                openMenu();
            }
        };

        // Set all mega-nav submenus as inert initially so closed panels are not tabbable
        var allMegaNavs = mobilemenuEl.querySelectorAll('.mega-nav');
        for (var i = 0; i < allMegaNavs.length; i++) {
            allMegaNavs[i].inert = true;
        }

        //Mobile Submenu
        var hassubmenu = document.querySelectorAll("#mob-menu .has-megamenu > button");
        for (var i = 0; i < hassubmenu.length; i++) {
            hassubmenu[i].onclick = function (e) {
                e.preventDefault();

                var el = e.target;
                var showmenu = el.nextElementSibling;
                if (showmenu) {
                    showmenu.classList.toggle('open');
                    el.classList.toggle('open');
                    var isOpen = showmenu.classList.contains('open');
                    el.setAttribute('aria-expanded', isOpen);
                    showmenu.inert = !isOpen;
                }

            };
        }

        //Mobile Submenu Close
        var backbuttons = document.querySelectorAll(".submenu-actions__back");
        for (var i = 0; i < backbuttons.length; i++) {
            backbuttons[i].onclick = function (e) {
                e.preventDefault();
                var megamanus = document.querySelectorAll(".mega-nav.open");
                for (var x = 0; x < megamanus.length; x++) {
                    megamanus[x].classList.remove('open');
                    megamanus[x].inert = true;
                    var trigger = megamanus[x].previousElementSibling;
                    if (trigger && trigger.hasAttribute('aria-expanded')) {
                        trigger.classList.remove('open');
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                }

            };
        }

        //Submenu Accordions
        var submenutitles = document.querySelectorAll('.mega-nav__title');
        for (var i = 0; i < submenutitles.length; i++) {
            submenutitles[i].onclick = function (e) {
                var el = e.target;
                el.classList.toggle('open');

                if (el.nextElementSibling) {
                    el.nextElementSibling.classList.toggle('open');
                }
            }
        }

        var submenuchilden = document.querySelectorAll(".menu-item-has-children");
        for (var i = 0; i < submenuchilden.length; i++) {
            submenuchilden[i].onclick = function (e) {
                var el = e.target;
                el.classList.toggle('open');

                if (el.nextElementSibling) {
                    el.nextElementSibling.classList.toggle('open');
                }
            }
        }

    }

}

export default mobilemenu;
